module.exports = __webpack_public_path__ + "static/media/24UHCHR15.259e55bf.jpg";